import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import Message from './layouts/Message';
import Body from './layouts/Body';
import Admin from './layouts/Admin';

import Home from './pages/Home';
import Profil from './pages/Profil';
import Access from './pages/Access';
import Meeting from './pages/Meeting';
import Wlist from './pages/Wlist';
import Signup from './pages/Signup';
import Error from './pages/Error';

import './App.css';

function App() {

    return (
        <React.StrictMode>
            <Message />

            <Routes>
                <Route path="/" element={<Body />}>
                    <Route index element={<Home />} />
                    <Route path="profil" element={<Profil />} />
                    <Route path="access" element={<Access />} />
                    <Route path="meeting" element={<Meeting />} />
                    <Route path="wlist" element={<Admin><Wlist /></Admin>} />
                    
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>

                <Route path="/signup" element={<Signup />} />
                <Route path="/error" element={<Error />} />
            </Routes>
        </React.StrictMode>
    );
}

export default App;